import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PageShell } from "@/components/layout/PageShell";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSection {
  title: string;
  items: FaqItem[];
}

const FaqPage = () => {
  const { t } = useTranslation("faq");
  // Only an English FAQ bundle exists today — regulatory/compliance content
  // like this needs a professional translation review before shipping in
  // other languages, so it intentionally falls back to English elsewhere.
  const faqSections = t("sections", { returnObjects: true }) as FaqSection[];

  return (
    <PageShell className="[scrollbar-gutter:stable]">
      <h1 className="text-xl font-semibold text-gray-900">{t("pageTitle")}</h1>

      <div className="mx-auto mt-6 w-full max-w-5xl space-y-8">
          {faqSections.map((section, sectionIndex) => (
            <div
              key={sectionIndex}
              className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
            >
              <h2 className="mb-4 text-base font-bold text-gray-950 sm:text-lg">
                {section.title}
              </h2>

              <Accordion type="single" collapsible className="w-full">
                {section.items.map((item, itemIndex) => (
                  <AccordionItem
                    key={itemIndex}
                    value={`${sectionIndex}-${itemIndex}`}
                    className="border-b border-gray-100"
                  >
                    <AccordionTrigger className="text-left text-[15px] font-semibold text-gray-900 hover:no-underline sm:text-base">
                      {item.question}
                    </AccordionTrigger>

                    <AccordionContent className="pb-4 text-[15px] leading-7 text-gray-700 sm:text-base sm:leading-8">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
      </div>
    </PageShell>
  );
};

export default FaqPage;
